import React from "react";
import {
  Link as RouterLink,
  Outlet as RouterOutlet,
  useLocation,
  useNavigate as useReactRouterNavigate,
} from "react-router-dom";

export function Link({ to, children, ...props }) {
  return (
    <RouterLink to={to} {...props}>
      {children}
    </RouterLink>
  );
}

export const Outlet = RouterOutlet;

export function useNavigate() {
  const navigate = useReactRouterNavigate();
  return (target) => {
    if (typeof target === "string") {
      navigate(target);
      return;
    }
    navigate(target?.to || "/");
  };
}

export function useRouterState({ select }) {
  const location = useLocation();
  const state = { location };
  return typeof select === "function" ? select(state) : state;
}

export function useRouter() {
  const location = useLocation();
  const navigate = useNavigate();
  return { state: { location }, navigate };
}

export function createFileRoute(path) {
  return (options) => ({
    options: { ...options, path },
  });
}

export function createRootRoute(options) {
  return {
    options,
  };
}

export function HeadContent() {
  return null;
}

export function Scripts() {
  return null;
}
